import { Shield } from "@phosphor-icons/react";
import { useState, useEffect } from "react";
import api from "@/lib/api";

const DEFAULT_LOGO_URL = "https://customer-assets.emergentagent.com/job_padel-hub-12/artifacts/1l51i82c_IMG_9692.jpeg";

let _cachedLogoUrl = null;
let _logoPromise = null;
function fetchLogoOnce() {
  if (_cachedLogoUrl) return Promise.resolve(_cachedLogoUrl);
  if (_logoPromise) return _logoPromise;
  _logoPromise = api.get("/padel-center/logo").then((r) => {
    _cachedLogoUrl = r.data?.url || DEFAULT_LOGO_URL;
    return _cachedLogoUrl;
  }).catch(() => DEFAULT_LOGO_URL);
  return _logoPromise;
}
export function invalidatePCLogoCache() { _cachedLogoUrl = null; _logoPromise = null; }

/**
 * Padel Center logo placeholder.
 * Tries to load logo from backend (admin-uploaded), falls back to default.
 */
export default function PadelCenterLogo({ size = 96, withText = true, glow = false, className = "" }) {
  const [url, setUrl] = useState(_cachedLogoUrl || DEFAULT_LOGO_URL);
  useEffect(() => { fetchLogoOnce().then((u) => u && setUrl(u)); }, []);
  return (
    <div className={`inline-flex items-center gap-3 ${className}`} data-testid="padel-center-logo">
      <div className="relative shrink-0" style={{ width: size, height: size }}>
        {glow && <div className="absolute inset-0 rounded-full blur-2xl opacity-70 bg-[#CCFF00]/40" aria-hidden />}
        <img src={url} alt="Padel Center" className="absolute inset-0 w-full h-full object-cover rounded-full border-2 border-[#CCFF00]/60 shadow-xl" onError={(e) => { e.currentTarget.src = DEFAULT_LOGO_URL; }} />
        <Shield size={size * 0.22} weight="fill" className="absolute -bottom-1 -right-1 text-[#CCFF00] drop-shadow-lg" />
      </div>
      {withText && (
        <div className="flex flex-col">
          <span className="text-[10px] tracking-[0.35em] uppercase text-[#CCFF00]/70 font-bold">Ecosistema Privado</span>
          <span className="font-['Barlow_Condensed'] text-2xl font-black uppercase tracking-tight text-white leading-tight">PADEL CENTER</span>
          <span className="text-[10px] text-gray-400 italic">Club de Campeones</span>
        </div>
      )}
    </div>
  );
}

export function PadelCenterBadge({ size = 18, className = "" }) {
  const [url, setUrl] = useState(_cachedLogoUrl || DEFAULT_LOGO_URL);
  useEffect(() => { fetchLogoOnce().then((u) => u && setUrl(u)); }, []);
  return (
    <span
      className={`inline-flex items-center justify-center rounded-full overflow-hidden border border-[#CCFF00]/60 shrink-0 ${className}`}
      style={{ width: size, height: size }}
      title="Miembro Padel Center"
      data-testid="padel-center-badge"
    >
      <img src={url} alt="PC" className="w-full h-full object-cover" onError={(e) => { e.currentTarget.src = DEFAULT_LOGO_URL; }} />
    </span>
  );
}
